import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormSpy } from 'react-final-form';
import utils from 'utils';

// update final form values for pickup and return date
// whenever the pickup date is later than the return date, clear the return date
// and manage the pickup date
const LocationDateTimeFormSpy = ({ form }) => {
  const [lastActiveField, setLastActiveField] = useState(null);

  const handleChange = useCallback(
    (formState) => {
      let { pickupDate, returnDate } = formState.values;

      // Track the last active field to infer what the user is changing
      setLastActiveField(formState.active || lastActiveField);

      if (pickupDate && returnDate) {
        // Make sure we're comparing date/moment objects
        // Some values may initially appear as strings
        pickupDate = utils.gmi.getDateTimeObjFromTs(pickupDate, typeof pickupDate === 'string' ? 'YYYY-MM-DD' : null);
        returnDate = utils.gmi.getDateTimeObjFromTs(returnDate, typeof returnDate === 'string' ? 'YYYY-MM-DD' : null);

        if (pickupDate.isAfter(returnDate)) {
          form.change('returnDate', '');
          // If the return date was set earlier than pickup, use that date as the pickup
          if (lastActiveField === 'returnDate') {
            form.change('pickupDate', returnDate.toDate());
          }
        }
      }
    },
    [lastActiveField, form]
  );

  return (
    <FormSpy
      onChange={(formState) => setTimeout(() => handleChange(formState), 0)}
      subscription={{ active: true, values: true }}
    />
  );
};

LocationDateTimeFormSpy.propTypes = {
  form: PropTypes.object.isRequired,
};

export default LocationDateTimeFormSpy;
